export const getValueText = (
  value: any,
  options: { label: any; value: any }[]
) => {
  if (value instanceof Array) {
    const labels = options
      .filter((item) => value.includes(item.value))
      .map((item) => item.label);

    return labels;
  }
  return options.find((item) => item.value === value)?.label || '';
};
